import React from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import { loadGA } from 'utils/googleAnalytics';
// import { loadHappierLeads } from 'utils/happierLeads';
import { loadHubSpot } from 'utils/hubSpot';
import { loadStonlyWidget } from 'utils/stonly';
import { isCacheFly } from 'utils/whiteLabeling';

import { AlertNotificationProvider } from './components/AlertNotifications/AlertNotificationProvider';
import { ConfirmationDialogProvider } from './components/ConfirmationDialog/ConfirmationDialogProvider';
import { WizardProvider } from './containers/Pages/ServiceLandingPage/components/Wizard/WizardProvider';
import Routes from './routes';
import { store } from './store';

import 'styles/app.scss';
import 'styles/mirna/new-portal.scss';

if (process.env.REACT_APP_ENV === 'production' && isCacheFly) {
  loadGA();
  // loadHappierLeads();
  loadHubSpot();
}

if (process.env.REACT_APP_ENV === 'production') {
  // Disable console.log in production
  console.log = function () {};
}

if (isCacheFly) {
  loadStonlyWidget();
}

const queryClient = new QueryClient();

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <ConfirmationDialogProvider>
        <AlertNotificationProvider>
          <WizardProvider>
            <Routes />
          </WizardProvider>
        </AlertNotificationProvider>
      </ConfirmationDialogProvider>
      <ToastContainer autoClose={1500} hideProgressBar theme="colored" />
    </QueryClientProvider>
  </Provider>,
  // </React.StrictMode>,
);
